import { getAnalyticsApiBase } from "../services/analyticsApiBase";

/**
 * True when a request targets the analytics-api-service rather than the primary API.
 *
 * Analytics is a secondary data source: its callers degrade to the Java endpoints when
 * it is unavailable (see dashboardService.getPatientStatsForStaff). It is not
 * session-authoritative, so a 401 from it must not trigger a global logout — that would
 * turn an analytics misconfiguration, such as a JWT signing-secret mismatch between the
 * two services, into a clinical-workflow outage.
 *
 * @param {string} url - the request URL
 * @returns {boolean}
 */
export function isAnalyticsRequest(url) {
  if (typeof url !== "string" || !url) return false;
  const base = getAnalyticsApiBase();
  if (base && url.startsWith(base)) return true;
  // Defensive: analytics is always its own host, never a path on the primary API.
  return /^https?:\/\/[^/]*mps-analytics[^/]*\./i.test(url);
}

export default isAnalyticsRequest;
